import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 列表页-筛选区
 * @author alfielv
 */
import _ from 'lodash';
import React, { useCallback, useRef, useState } from 'react';
import { Icon as SpauiIcon } from '@tencent/spaui';
import FilterItem from './FilterItem';
import Icon from '../../Icon';
import useVisibleFilters from './useVisibleFilters';
export default (function (props) {
  var prefixCls = props.prefixCls,
      controls = props.controls,
      filterData = props.filterData,
      customFilterComponent = props.customFilterComponent,
      resetable = props.resetable,
      defaultFilterData = props.defaultFilterData,
      activeFilterKeys = props.activeFilterKeys,
      bizFilterKeys = props.bizFilterKeys,
      filterMap = props.filterMap,
      setFilterData = props.setFilterData,
      setPageNo = props.setPageNo,
      expandFilterCount = props.expandFilterCount;

  var _useVisibleFilters = useVisibleFilters({
    controls: controls,
    filterMap: filterMap,
    filterData: filterData,
    setFilterData: setFilterData,
    activeFilterKeys: activeFilterKeys,
    bizFilterKeys: bizFilterKeys
  }),
      visibleFilters = _useVisibleFilters.visibleFilters;

  var defaultValueAreSetRef = useRef({}); // 更新filterData

  var onFilterDataUpdate = useCallback(function (data) {
    var type = data.type,
        key = data.key,
        value = data.value,
        _data$deleteKeys = data.deleteKeys,
        deleteKeys = _data$deleteKeys === void 0 ? [] : _data$deleteKeys;

    if (type === 'UPDATE') {
      setFilterData(function (prevFilterData) {
        // filterData发生改变立即更新PageNo为1
        setPageNo(1);
        return _objectSpread(_objectSpread({}, prevFilterData), {}, _defineProperty({}, key, value));
      });
    } else if (type === 'DELETE') {
      setFilterData(function (prevFilterData) {
        // filterData发生改变立即更新PageNo为1
        setPageNo(1);
        return _.omit(prevFilterData, [key]);
      });
    } else if (type === 'UPDATE_AND_DELETE') {
      setFilterData(function (prevFilterData) {
        // filterData发生改变立即更新PageNo为1
        setPageNo(1);
        return _objectSpread(_objectSpread({}, _.omit(prevFilterData, deleteKeys)), {}, _defineProperty({}, key, value));
      });
    } else {
      console.error('ERROR in ListView component: filter data update type error!');
    }
  }, [setFilterData, setPageNo]); // 重置filterData为默认值

  var handleFilterDataReset = useCallback(function () {
    setFilterData(function () {
      // filterData发生改变立即更新PageNo为1
      setPageNo(1);
      return defaultFilterData;
    });
  }, [defaultFilterData, setFilterData, setPageNo]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1]; // 有展开控制


  if (Number(expandFilterCount) > 0) {
    visibleFilters = _.take(visibleFilters, open ? _.size(visibleFilters) : expandFilterCount);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__filter-area")
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-filter"
  }), /*#__PURE__*/React.createElement("div", {
    className: "filter-list"
  }, _.map(visibleFilters, function (filterItem) {
    var name = filterItem.name,
        defaultValue = filterItem.defaultValue;

    var value = function () {
      if (defaultValueAreSetRef.current[name]) {
        return _.get(filterData, name);
      }

      defaultValueAreSetRef.current[name] = true;
      return defaultValue;
    }();

    return /*#__PURE__*/React.createElement(FilterItem, _extends({}, filterItem, {
      key: name,
      value: value,
      onFilterDataUpdate: onFilterDataUpdate
    }));
  }), customFilterComponent), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__filter-area__refresh-btn")
  }, Number(expandFilterCount) > 0 && /*#__PURE__*/React.createElement(SpauiIcon, {
    style: {
      marginRight: 5
    },
    name: open ? 'more-outlined' : 'custom-outlined',
    onClick: function onClick() {
      setOpen(!open);
    }
  }), resetable && /*#__PURE__*/React.createElement("span", {
    onClick: handleFilterDataReset
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "refresh"
  }))));
});